import { render, staticRenderFns } from "./lstGame.vue?vue&type=template&id=465b7c2c"
import script from "./lstGame.vue?vue&type=script&lang=js"
export * from "./lstGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports